import Pill from "@irati/ui/src/Pill"
import styled from "styled-components"

export default styled(Pill)`
  z-index: 2;
  position: absolute;
  margin: ${({theme}) => theme.spacing.two};
  background-color: ${({theme}) => theme.colors.tertiary.r_200};
`
